import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';


const SliderWithThumbs = ({ slides }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <div className="slider-wrapper">
            {/* Main Swiper */}
            <Swiper
                modules={[Navigation, Thumbs, Autoplay]}
                spaceBetween={10}
                // navigation
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                thumbs={{ swiper: thumbsSwiper }}
                loop
                className="main-swiper"
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide-content">
                            {slide.content}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Thumbnail Swiper (HTML thumbs) */}
            <Swiper
                onSwiper={setThumbsSwiper}
                spaceBetween={16}
                slidesPerView={2}
                freeMode={true}
                watchSlidesProgress={true}
                // centeredSlides={true}
                modules={[Thumbs]}
                className="thumbs-swiper "
                breakpoints={{
                    0: { slidesPerView: 0 },
                    768: { slidesPerView: 0 },
                    1200: { slidesPerView: 2 },
                }}
            >
                {slides.map((slide, index) => (

                    <SwiperSlide key={index}>

                        <div className="thumb">{slide.thumb}</div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default SliderWithThumbs;
